import React, { createContext, useState } from "react";
// import { db, auth } from "./Firebase-Config";



export const GeneralUtilsContext = createContext();

const GeneralUtilsContextProvider = (props) => {
  const [pending, setPending] = useState(false);

  if (pending) {
    return <>Loading...</>;
  }

  //SHUFFLER

  function shuffle(array) {
    let currentIndex = array.length,
      randomIndex;

    // While there remain elements to shuffle.
    while (currentIndex !== 0) {
      // Pick a remaining element.
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;

      // And swap it with the current element.
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex],
        array[currentIndex],
      ];
    }

    return array;
  }

  return (
    <GeneralUtilsContext.Provider
      value={{
        pending,
        setPending,
        shuffle,
      }}
    >
      {props.children}
    </GeneralUtilsContext.Provider>
  );
};

export default GeneralUtilsContextProvider;
